import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import MoneyOffOutlinedIcon from '@mui/icons-material/MoneyOffOutlined';
import ExplicitOutlinedIcon from '@mui/icons-material/ExplicitOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';

export const NavigationBuilder = (userDept) => {
  // Return empty features array if userDept is undefined
  if (!userDept) {
    return [{
      id: 'applications',
      title: 'Applications',
      translate: 'APPLICATIONS',
      type: 'group',
      icon: 'apps',
      children: []
    }];
  }

  let features = [];
  const isTechOrFinance = userDept === 'Finance' || userDept === 'Technology';
  const isWebBiUser = true; // isTechOrFinance || userDept === 'BD and Sales & Marketing';
  const isDev = process.env.REACT_APP_ENVIRONMENT === 'dev';
  const loggedIn = userDept !== '';

  if (loggedIn) {
    features = [
      {
        id: 'applications',
        title: 'Applications',
        translate: 'APPLICATIONS',
        type: 'group',
        icon: 'apps',
        children: [
          {
            id: 'invoice',
            title: 'Invoices',
            icon:  <DescriptionOutlinedIcon />,
            children: [
              {
                id: 'invoices-list',
                title: 'Invoice List',
                icon: <ReceiptOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/invoices/list`,
              },
              {
                id: 'receipt-list',
                title: 'Receipt List',
                icon: <ReceiptOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/receipt/list`,
              },
            ],
          },
          {
            id: 'customer-details',
            title: 'Customer Details',
            icon: <PeopleOutlineOutlinedIcon />,
            url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/customers`,
            children: [
              {
                id: 'customer-info',
                title: 'Customer Info',
                icon: <ContactsOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/customers`,
              },
              {
                id: 'cabling-suspension',
                title: 'Cabling Suspension',
                icon: <EventBusyOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/customers/cabling-suspension`,
              },
            ],
          },
          {
            id: 'reports-details',
            title: 'Report Details',
            type: 'collapse',
            icon: <AssessmentOutlinedIcon />,
            children: [
              {
                id: 'soa-report',
                title: 'SOA Report',
                type: 'item',
                icon: <AccountBalanceOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/reports/soa-report`,
              },
              {
                id: 'payment-reminder-report',
                title: 'Payment Reminder Report',
                type: 'item',
                icon: <MoneyOffOutlinedIcon />,
                url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/reports/payment-reminder-report`,
              },
            ],
          },
        ],
      },
    ];
  }

  if (isTechOrFinance || isDev) {

    features[0].children.push({
      id: 'invoicePrinting',
      title: 'E-Invoice',
      type: 'collapse',
      icon: <ExplicitOutlinedIcon />,
      children: [
        {
          id: 'invoices-template-config',
          title: 'Invoice Template Config',
          icon: <BuildOutlinedIcon />,
          url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/invoices/template`,
        },
        {
          id: 'invoices-notification',
          title: 'Invoice Sender',
          icon: <EmailOutlinedIcon />,
          url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/invoices/notification/send`,
        },
        {
          id: 'invoices-notification-approve',
          title: 'Invoice Sender Approval',
          type: 'item',
          icon: <SupervisorAccountOutlinedIcon />,
          url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/invoices/notification/approve`,
        },
        {
          id: 'invoices-notification-history',
          title: 'Invoice Sender Log',
          icon: <RestoreOutlinedIcon />,
          url: `${process.env.REACT_APP_EBILL_WEB_URL}/apps/invoices/notification/history`,
        },
      ],
    });

  }

  // Webbi temporary available for dev/uat only
  if ((isWebBiUser && process.env.REACT_APP_STAGE !== 'PROD') || isDev) {
    features[0].children.push({
      id: 'billing',
      title: 'Billing',
      icon: <BallotOutlinedIcon style={{ color: '#61dafb' }} />,
      children: [
        {
          id: 'billing-instruction',
          title: 'Billing Instruction',
          icon: <SubtitlesOutlinedIcon style={{ color: '#61dafb' }} />,
          url: process.env.PUBLIC_URL + '/',
        },
        {
					id: 'billing-instruction-report',
					title: 'Report',
					// icon: 'assessment',
          icon: <AssessmentOutlinedIcon style={{ color: '#61dafb' }} />,
					url: `/report`
				}
      ],
    });
  }
  return features;

};
